import { InductionProvider } from "../../hooks/useInduction";
import Home from '../../components/Home'


export default function Dashboard() {
    return (
        <InductionProvider>
            <Home />
        </InductionProvider>
    )
}